import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { connect } from 'react-redux'

/* Simple utility class to handle page title changes */
class PageTitleHandler extends React.Component {
    render(){
        return (
            <Switch>
                <Route path="/immunizations" render={() => {
                    document.title = this.props.strings.PAGE_TITLE_IMMUNIZATIONS
                }}/>
                <Route path="/*" render={() => {
                    document.title = this.props.strings.PAGE_TITLE
                }}/>
            </Switch>
        )
    }
}


const mapStateToProps = (state, ownProps) => {
    return {
        strings: state.language.strings,
    }
}

export default connect(mapStateToProps)(PageTitleHandler);
